<twc-popup caption="{{'RELATED_PROJECTS.TITLE' | translate }}" type="primary" width="m"
    class="related-projects-container">
    <twc-popup-content>
        <p *ngIf="description" [innerHTML]="description"></p>

        <div class="twc-message-box twc-message-box-error twc-mb-4" *ngIf="errorMsg">{{errorMsg | translate}}</div>

        <ng-container *ngIf="!errorMsg">
            <div *ngIf="!isLoading; else showLoading">
                <twc-list *ngIf="projectList?.length; else notResultsFound" class="related-project-list">
                    <twc-list-item *ngFor="let project of projectList">
                        <div class="twc-list-item-col-2 word-break">{{project.name}}</div>
                        <div class="twc-list-item-col-3 icons-container">
                            <twc-icon shape="open-in-browser" [size]="24" class="twc-mr-2 cursor-pointer"
                                color="twc-topcon-blue" (click)="onOpenViewerClicked(project)"
                                twcTooltip="{{'RELATED_PROJECTS.OPEN_VIEWER' | translate}}"></twc-icon>
                            <twc-icon shape="delete" class="remove-icon" (click)="onDettachObjectClicked(project)"
                                [ngClass]="{'disabled-icon': !hasPermissionsToUpdateProject(project)}"
                                twcTooltip="{{'RELATED_PROJECTS.REMOVE_FROM_PROJECT' | translate}}"></twc-icon>
                        </div>
                    </twc-list-item>
                </twc-list>
                <ng-template #notResultsFound>
                    <span class="no-results">{{'GENERAL.NOT_RESULTS_FOUND' | translate}}</span>
                </ng-template>
            </div>
        </ng-container>
    </twc-popup-content>
</twc-popup>

<ng-template #showLoading>
    <twc-loader class="loader-position" size="tiny"></twc-loader>
</ng-template>